import CancellableHelper from "@/requests/CancellableHelper";
import { Chart, Statistics } from "@/models/api/statistics/Statistics";

//#region Routes
export const URL_GET_CHART = "/Dashboard/Chart/${Name}";
export const URL_GET_DASHBOARD_STATISTICS = "/Dashboard/Statistics";
//#endregion

const _getStatistics = new CancellableHelper<Statistics>(URL_GET_DASHBOARD_STATISTICS, Statistics);
export const getStatistics = async (): Promise<Statistics> => {
  return await _getStatistics.get();
};

const _getChart = new CancellableHelper<Chart>(URL_GET_CHART, Chart);
export const getChart = async (name: string): Promise<Chart> => {
  return await _getChart.get({ Name: name });
};
